import { useEffect } from "react";
import { FormActions } from "../../components/common/FormActions";
import { BooleanTags } from "../../components/common/registerUtils";
import {
  API_CUSTOMER_CONFIGURABLE_MERCHANTS,
  API_MERCHANT_SERVICE_ACCESS,
} from "../../utils/apis";
import { createViewEdit, getForm, getRegister } from "../../utils/helpers";
import { URL_MERCHANT_SERVICE_ACCESS } from "../../utils/urls";
import useGet from "../common/useGet";

const url = URL_MERCHANT_SERVICE_ACCESS;

export const useMerchantServiceAccess = () => {
  const tableColumns = () => [
    {
      id: "merchant_name",
      header: "Merchant Name",
      filter: {},
    },
    {
      id: "service_code",
      header: "Service Code",
      filter: {},
    },
    {
      id: "service_code_name",
      header: "Service Code Name",
      filter: {},
    },
    {
      id: "is_active",
      header: "Is Active",
      filter: {},
    },
    {
      id: "api_acess",
      header: "API Access",
      filter: {},
    },
    {
      id: "web_acess",
      header: "Web Access",
      filter: {},
    },
    {
      id: "mobile_acess",
      header: "Mobile Access",
      filter: {},
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_active: <BooleanTags status={item?.is_active} />,
        api_acess: <BooleanTags status={item?.api_acess} />,
        web_acess: <BooleanTags status={item?.web_acess} />,
        mobile_acess: <BooleanTags status={item?.mobile_acess} />,
        actions: <FormActions actions={[...createViewEdit(url, item?.id)]} />,
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Merchant Service Access Details",
          fields: {
            merchant_Id: item?.merchant_Id,
            service_code: item?.service_code,
            is_active: <BooleanTags status={item?.is_active} />,
            api_acess: <BooleanTags status={item?.api_acess} />,
            web_acess: <BooleanTags status={item?.web_acess} />,
            mobile_acess: <BooleanTags status={item?.mobile_acess} />,
          },
        },
      ],
    };
  };

  const formRoute = getForm(url);

  return { tableColumns, tableData, viewData, formRoute };
};

export const useMerchantServiceAccessForm = () => {
  const {
    data: merchantIDs,
    loading: merchantIDsLoading,
    loadData: merchantIDsLoadData,
  } = useGet();

  useEffect(() => {
    merchantIDsLoadData({ api: API_CUSTOMER_CONFIGURABLE_MERCHANTS });
  }, []);

  const sections: any = [
    {
      title: "Merchant Service Access Details",
      fields: [
        {
          field_name: "merchant_Id",
          type: "select",
          props: {
            required: true,
          },
          options_data: merchantIDs?.map((item: any) => ({
            id: item?.id,
            name: item?.name,
          })),
        },
        {
          field_name: "service_code",
          type: "text",
          props: {
            required: true,
          },
        },
        {
          field_name: "is_active",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "api_acess",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "web_acess",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
        {
          field_name: "mobile_acess",
          type: "select",
          props: {
            required: true,
          },
          options_data: [
            { id: true, name: "True" },
            { id: false, name: "False" },
          ],
        },
      ],
    },
  ];

  const redirect = getRegister(url);

  return { sections, redirect, merchantIDs, merchantIDsLoading };
};

export const submitMerchantServiceAccess = (
  payload: any,
  id: string | number,
) => {
  // Filter out _name fields that are added by select inputs
  const cleanPayload = Object.keys(payload).reduce((acc, key) => {
    if (!key.endsWith("_name")) {
      acc[key] = payload[key];
    }
    return acc;
  }, {} as any);

  if (id) {
    return {
      api: `${API_MERCHANT_SERVICE_ACCESS}${id}/update/`,
      params: cleanPayload,
    };
  }

  //   CREATE
  return {
    api: `${API_MERCHANT_SERVICE_ACCESS}create/`,
    params: cleanPayload,
  };
};
